import { Card, CardHeader } from "../../components/ui";
import { useTranslation } from "react-i18next";
import { DatabaseLogs } from "../../components/DatabaseLogs";
import { useDatabaseTabContext } from "./context";

export function DatabaseLogsTab() {
  const { t } = useTranslation("database");
  const { orgId, database } = useDatabaseTabContext();

  return (
    <Card>
      <CardHeader
        title={t("logs.title")}
        description={t("logs.description")}
      />
      <div className="p-5">
        <DatabaseLogs orgId={orgId} databaseId={database.id} />
      </div>
    </Card>
  );
}
